import React from 'react';
import { CommonProps } from '../Element/Element';
import Div from '../Element/Div/Div';
import SideNavigationItem, {
  SideNavigationItemType,
} from './SideNavigationItem/SideNavigationItem';

export type SideNavigationProps = {
  /** Navigation Items Props */
  navigationItems: SideNavigationItemType[];
} & CommonProps<'div'>;

const SideNavigation: React.FunctionComponent<SideNavigationProps> & {
  Item: typeof SideNavigationItem;
} = ({ navigationItems, ...props }) => {
  return (
    <Div {...props}>
      {navigationItems.map(
        ({ iconName, label, subItems, onClick, active, ...props }) => (
          <SideNavigationItem
            iconName={iconName}
            label={label}
            onClick={onClick}
            active={active}
            subItems={subItems}
            {...props}
          />
        )
      )}
    </Div>
  );
};

SideNavigation.Item = SideNavigationItem;

export default SideNavigation;
